import {animate, AnimationBuilder, AnimationMetadata, style} from '@angular/animations';
import {Directive, ElementRef, Input} from '@angular/core';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector

    selector: '[appCollapse]',
    exportAs: 'CollapseDirective'
})
export class CollapseDirective {
    private expanded = true;

    @Input() expandedWidth = '13.5rem';
    @Input() collapsedWidth = '55px';
    @Input() set initiallyExpanded(defaultState: boolean) {
        this.expanded = defaultState;
        this.initialize();
    }

    constructor(
        private builder: AnimationBuilder,
        private el: ElementRef
    ) {}

    private collapseAnimation(animationTiming = '400ms'): AnimationMetadata[] {
        return [
            style({width: '*', 'min-width': '*'}),
            animate(
                `${animationTiming} ease-out`,
                style({
                    width: this.collapsedWidth,
                    'min-width': this.collapsedWidth
                })
            )
        ];
    }

    private expandAnimation(animationTiming = '400ms'): AnimationMetadata[] {
        return [
            style({width: '*', 'min-width': '*'}),
            animate(
                `${animationTiming} ease-out`,
                style({
                    width: this.expandedWidth,
                    'min-width': this.expandedWidth
                })
            )
        ];
    }

    private initialize(): void {
        this.expanded ? this.expand() : this.collapse();
    }

    toggle(): void {
        const animationMeta = this.expanded ? this.collapseAnimation() : this.expandAnimation();

        const factory = this.builder.build(animationMeta);
        const player = factory.create(this.el.nativeElement);

        player.play();
        this.expanded = !this.expanded;
    }

    expand(animationTiming = '400ms'): void {
        const factory = this.builder.build(this.expandAnimation(animationTiming));
        const player = factory.create(this.el.nativeElement);

        player.play();
        this.expanded = true;
    }

    collapse(animationTiming = '400ms'): void {
        const factory = this.builder.build(this.collapseAnimation(animationTiming));
        const player = factory.create(this.el.nativeElement);

        player.play();
        this.expanded = false;
    }
}
